import React from 'react';
import { PropTypes } from 'prop-types';

import { Button } from '@ipc/ipc-components';
import { AppContentInner, AppContentTitle } from '../../styles';
import InvoiceInformationListTable from '../../components/custom/InvoiceInformationListTable';
import { ButtonsWrapper } from '../ReceptaclesList/styles';


function RecordsList({ history, location: { search }, match: { params: { filter = '' } } }) {
  const urlParams = new URLSearchParams(search);
  const recordId = urlParams.get('invoiceNumber');

  return (
    <AppContentInner>
      <AppContentTitle>Invoice Information</AppContentTitle>
      <InvoiceInformationListTable recordId={recordId} filter={filter} search={search} />
      <ButtonsWrapper marginTop="0px">
        <Button className="CancelButton" onClick={history.goBack}>Back</Button>
      </ButtonsWrapper>
    </AppContentInner>
  );
}

RecordsList.propTypes = {
  history: PropTypes.shape(),
  location: PropTypes.shape(),
  match: PropTypes.shape(),
};

export default RecordsList;
